import ModalHeader from './modalHeader-TEMPLATE_VERSION'

export default ModalHeader
